import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  loading: false,
  error: null,
  summaryData: {},
};

const tatMonitoringSummarySlice = createSlice({
  name: "tatMonitoringSummary",
  initialState,
  reducers: {
    fetchSummary: (state, action) => {
      state.loading = true;
      state.error = null;
      state.summaryData = {};
    },
    fetchSummarySuccess: (state, action) => {
      state.loading = false;
      state.summaryData = action.payload?.data || {};
    },
    fetchSummaryFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const { actions, reducer } = tatMonitoringSummarySlice;
export const sliceKey = tatMonitoringSummarySlice.name;